import { Box, Button, Container, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import NativeSelect from '@mui/material/NativeSelect';
import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import axios from "axios";
import { useEffect } from 'react';
import { ABI, API_URL, APP_URL, bsccontractaddress, Bsc_Chainid, ethcontractaddress, ETH_Chainid, maticcontractaddress, Matic_Chainid } from '../../Config';
import { useWeb3React } from '@web3-react/core';
import swal from "sweetalert";
import Loading from "../../Components/loader/loader";
import tokenabi from "../../Config/tokenabi.json";
import { useCheckChain } from '../../Hooks/useCheckChain';

/* global BigInt */
const Resell = () => {
    const [nftdata, Setdata] = useState([]);
    const { id } = useParams();
    const [resellprice, Setresell] = useState("");
    const { library, account ,chainId} = useWeb3React();
    const [isloading, setisloading] = useState(false);
    const history =useHistory();
    const { switchChain } = useCheckChain();

    const fetchdata = async () => {
        let data = await axios.get(`${API_URL}/buyItem.php?id=${id}`, {
            headers: {
                "Content-Type": "application/json",
            },

        })
        await Setdata(data);

    }
    useEffect(() => {
        fetchdata();
    }, [])


    const Resell = async (owneraddress, Nftchainid, Paymentcurrency,ismembernft) => {
        if (library) {
        if(resellprice>0){
            if(Number(chainId)== Number(Nftchainid)){
            if(owneraddress==account){ 

            setisloading(true);
            let contract_address;    
            if (Nftchainid == Bsc_Chainid) {
                contract_address = bsccontractaddress;
            } else if (Nftchainid == Matic_Chainid) {
                contract_address = maticcontractaddress;
            } else if(Nftchainid == ETH_Chainid){
                contract_address= ethcontractaddress;
            }

            resellnft(resellprice,contract_address,Paymentcurrency,ismembernft)

            }else{
                swal({
                    title: "Warning",
                    text: "You are not the owner of the NFT",
                    icon: "error",
                    allowOutsideClick: false,
                    confirmButtonText: 'ok',
                    confirmButtonColor: '#2dbe60',
                })
            }
        }else{
            swal({
                title: "Warning",
                text: "Switch to the correct Network",
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: 'ok',
                confirmButtonColor: '#2dbe60',
            }).then(()=>{
                switchChain(Number(Nftchainid));
            })          
        }
     
        }else{
            swal({
                title: "Warning",
                text: "Enter the Resell Value",
                icon: "error",
                allowOutsideClick: false,
                confirmButtonText: 'ok',
                confirmButtonColor: '#2dbe60',
            })
        }
     }
    }

    const resellnft = async (resellprice,contract_address, Paymentcurrency ,ismembernft) => {
   
        const Web3 = require("web3");
        const web3 = new Web3(library.provider);
        const contract = await new web3.eth.Contract(ABI, contract_address);
        let value = web3.utils.toWei(resellprice.toString(), "ether");

        if(ismembernft=='0'){

        await contract.methods.setTokenPrice(value, id.toString(), true, contract_address,false).estimateGas({
            from: account.toString(),
        }).then().catch(() => {
            setisloading(false);
        })
        await contract.methods.setTokenPrice(value, id.toString(), true, contract_address, false).send({
            from: account.toString(),
        }).then(async () => {
            let response = await update(id, resellprice);
            if (response.data.code == 200) {
                swal({
                    title: "Success",
                    text: response.data.message,
                    icon: "success",
                    allowOutsideClick: false,
                    confirmButtonText: 'ok',
                    confirmButtonColor: '#2dbe60',
                }).then(()=>{
                    
                    history.push('../Myitem');
                })
            } else if (response.data.code == 500) {
                swal({
                    title: "Warning",
                    text: response.data.message,
                    icon: "error",
                    allowOutsideClick: false,
                    confirmButtonText: 'ok',
                    confirmButtonColor: '#2dbe60',
                })
            }

            setisloading(false)
        }).catch(() => {
            setisloading(false);
        })

        }else if(ismembernft=='1'){

            await contract.methods.setMemberTokenPrice(value, id.toString(), true, contract_address).estimateGas({
                from: account.toString(),
            }).then().catch(() => {
                setisloading(false);
            })
            await contract.methods.setMemberTokenPrice(value, id.toString(), true, contract_address).send({
                from: account.toString(),
            }).then(async () => {
                let response = await update(id, resellprice);
                if (response.data.code == 200) {
                    swal({
                        title: "Success",
                        text: response.data.message,
                        icon: "success",
                        allowOutsideClick: false,
                        confirmButtonText: 'ok',
                        confirmButtonColor: '#2dbe60',
                    }).then(()=>{
                      
                        history.push('../Myitem');
                    })
                } else if (response.data.code == 500) {
                    swal({
                        title: "Warning",
                        text: response.data.message,
                        icon: "error",
                        allowOutsideClick: false,
                        confirmButtonText: 'ok',
                        confirmButtonColor: '#2dbe60',
                    })
                }
    
                setisloading(false)
            }).catch(() => {
                setisloading(false);
            })
        }
    }

    const update = async (id, resellprice) => {

        var data = new FormData();
        data.append("NFT_id", id);
        data.append("NFTprice", resellprice);

        return await axios.post(`${API_URL}/Resell.php`, data, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    }


    return (
        <>
            <Box className='contact_us'>
                <Box className='createcollection_bg'>
                    <Typography variant='h2' fontWeight='600' fontSize='45px'>
                        Resell
                    </Typography>
                </Box>
            </Box>

            <Box className="membership" margin={'3rem'}>
                <Container maxWidth='xl'>
                    <Grid container spacing={2}>
                        <Grid item lg={7} sm={6} md={6} xs={12}>
                            <Box className='DeFiChain'>
                                <Typography variant='h2' fontSize='30px' fontWeight='600' paddingBottom='20px'>List item for Sale</Typography>
                                {/* <Box className='mark' marginBottom='10px'>
                                    <Typography variant='h6' fontSize='16px'> Put On Marketplace <FormControlLabel sx={{ float: 'right' }} control={<Switch  defaultChecked  onChange={(e)=>Setswitch(e.target.value)}/>} label="" /> </Typography>
                                </Box> */}
                                <Typography variant='h2' fontWeight='600' fontSize='18px'> Network: {nftdata.data?.NFT_info?.NFT_chainid == Bsc_Chainid ? "Binance" : nftdata.data?.NFT_info?.NFT_chainid == Matic_Chainid ? "Polygon" : nftdata.data?.NFT_info?.NFT_chainid == ETH_Chainid ? "Ethereum" : ""} </Typography>

                                <Box>
                                    <FormControl fullWidth className='select_stand'>
                                        <InputLabel variant="standard" htmlFor="uncontrolled-native">
                                        </InputLabel>
                                        <NativeSelect defaultValue={nftdata.data?.NFT_info?.NFT_payment}
                                            inputProps={{ name: '', id: 'uncontrolled-native', }}>
                                            <option value={nftdata.data?.NFT_info?.NFT_payment}>{nftdata.data?.NFT_info?.NFT_payment}</option>

                                        </NativeSelect>
                                    </FormControl>
                                </Box>
                                <Box>
                                    <Typography variant='h6' fontSize='18px' paddingTop='10px'  > Price </Typography>
                                    <TextField id="outlined-basic" type='number' inputProps={{
                                    min:0,
                                    step:'any'
                                }} fullWidth onChange={(e) => Setresell(e.target.value)} />
                                </Box>
                                <Box marginY='15px'>
                                    <Button variant='contained' onClick={() => Resell(nftdata.data?.NFT_info?.NFT_owner_address	, nftdata.data?.NFT_info?.NFT_chainid, nftdata.data?.NFT_info?.PaymentCurrency,nftdata.data?.NFT_info?.Membernft)} >Resell</Button>
                                </Box>

                            </Box>
                        </Grid>
                        <Grid item lg={5} sm={6} md={6} xs={12}>
                            <Box className='DeFiChain'>
                                <Typography variant='h2' fontSize='30px' fontWeight='600' paddingBottom='20px'>Preview</Typography>
                                <Box>
                                    <img className='basicphoto' src={APP_URL + '/' + nftdata.data?.NFT_info?.NFT_image} />

                                </Box>
                                <Box display='flex' justifyContent='space-between'>
                                    <Typography variant='h2' fontSize='22px' fontWeight='600' paddingTop='15px'>{nftdata.data?.NFT_info?.NFT_name}</Typography>
                                    <Typography variant='h2' fontSize='15px' fontWeight='400' paddingTop='20px'>Price <span> <b>{nftdata.data?.NFT_info?.NFT_price} {nftdata.data?.NFT_info?.NFT_payment}</b>  </span> </Typography>
                                </Box>
                                <Box>
                                    <Typography variant='h6' fontSize='18px' fontWeight='300' paddingTop='15px'>
                                        {nftdata.data?.NFT_info?.NFT_discription}
                                    </Typography>
                                </Box>

                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            {isloading && <Loading  props={'Transaction in process, Please wait do not refresh the page...'}/>}
        </>
    )
}

export default Resell